import { render, staticRenderFns } from "./ItemParameter.vue?vue&type=template&id=94a33174&scoped=true&"
import script from "./ItemParameter.vue?vue&type=script&lang=js&"
export * from "./ItemParameter.vue?vue&type=script&lang=js&"
import style0 from "./ItemParameter.vue?vue&type=style&index=0&id=94a33174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a33174",
  null
  
)

export default component.exports